import { useCallback, useState } from 'react';

export type AsyncTask<T> = {
  loading: boolean;
  data?: T;
  error?: unknown;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAsyncTask = <TaskResult, Task extends (...args: unknown[]) => Promise<TaskResult>>(
  task: Task,
) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<TaskResult>();
  const [error, setError] = useState<unknown>();

  const execute = useCallback(
    async (...params: Parameters<Task>) => {
      setLoading(true);
      setError(undefined);
      setData(undefined);
      try {
        setData(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          await task(...params),
        );
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, setData, setError, task],
  );

  return { execute, loading, data, error };
};
